<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Standard Risk Item Text</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-flex xs12>
      <message :messages="messages"></message>
    </v-flex>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.itemNo }}</td>
        <td class="text-xs-left">{{ props.item.stdItemTxt }} - {{ formatTextLength(props.item.stdItemTxtDesc) }} </td>
        <td class="text-xs-right">
          <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click.native="doNew()" v-if="itemList.length > 0">New Standard Risk Item Text<v-icon>mdi-plus</v-icon></v-btn>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Standard Risk Item Text?
      <div class="title">{{deleteText}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import { mapActions } from 'vuex'
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
export default {
  data() {
    return {
      headers: [
        { text: 'Item No', value: 'itemNo' },
        { text: 'Standard Risk Text', value: 'stdItemTxt' },
        TableConst.tableActionHeader
      ],
      deleteText: '',
      promptRemove: false,
      stdRiskTxt: null,
      itemList: []
    }
  },
  computed: {
    stdRiskTxtMenu() {
      return this.$store.state.parameters.scheme.stdRiskTxtMenu
    }
  },
  watch: {
    'fetchItem': function (value) {
      if (value !== false) {
        if (this.ids.itemNo !== 'new') {
          this.fetchData(this.ids.itemNo)
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'stdRiskTxtMenuInit'
    ]),
    async fetchData(xRiskNo) {
      const expand = {
        scheme: this.ids.scheme,
        riskNo: this.ids.riskNo
      }
      if (this.stdRiskTxtMenu.init !== 1) {
        await this.stdRiskTxtMenuInit(expand)
      }
      await this.doItemList()
      const apiURI = this.stdRiskTxtMenu.menu.pkgStdItemTxts
      if (apiURI) {
        try {
          const expand = {
            scheme: this.ids.scheme,
            riskNo: this.ids.riskNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((stdRiskTxt) => {
              this.stdRisktxt = stdRiskTxt.stdRiskTxt
              const convertList = {
                scheme: stdRiskTxt.scheme,
                riskNo: stdRiskTxt.riskNo,
                itemNo: stdRiskTxt.itemNo,
                stdRiskTxt: stdRiskTxt.stdRiskTxt,
                stdItemTxt: stdRiskTxt.stdItemTxt,
                stdItemTxtDesc: stdRiskTxt.stdItemTxtDesc,
                stdRiskTxtDesc: stdRiskTxt.stdRiskTxtDesc
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.items = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Standard Risk Text')
      }
    },
    doReview(data) {
      this.$emit('doReview', data.item)
    },
    doNew() {
      this.$emit('doNew', this.stdRisktxt)
    },
    async doItemList() {
      this.resetMessages()
      const apiURI = this.stdRiskTxtMenu.menu.itemList
      if (apiURI) {
        try {
          const expand = {
            scheme: this.ids.scheme,
            riskNo: this.ids.riskNo
          }
          this.itemLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.itemList = data.itemList
          } else {
            this.itemList = []
            this.message(result.data)
          }
          this.itemLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL - Risk List')
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedText = data
        this.deleteText = data.itemNo + ' - ' + data.stdItemTxt
      }
    },
    async doRemove() {
      const apiURI = this.stdRiskTxtMenu.menu.pkgStdItemTxtDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          scheme: this.ids.scheme,
          riskNo: this.selectedText.riskNo,
          itemNo: this.selectedText.itemNo,
          stdRiskTxt: this.selectedText.stdRiskTxt,
          stdItemTxt: this.selectedText.stdItemTxt
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.loading = false
          this.fetchData(this.ids.riskNo)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Text')
      }
    }
  },
  props: {
    fetchItem: {
      type: Boolean,
      default: false
    },
    ids: {
      type: Object,
      default () {
        return {
          scheme: null,
          riskNo: null,
          itemNo: null
        }
      }
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
